var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseCircle = function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDB9A8",
    d: "m5.5 11.878 3-3 3 3 .878-.878-3-3 3-3-.878-.878-3 3-3-3L4.622 5l3 3-3 3zM8.5 15.917a7.7 7.7 0 0 1-3.087-.623A8 8 0 0 1 2.9 13.602a8 8 0 0 1-1.693-2.514 7.7 7.7 0 0 1-.624-3.086q0-1.643.624-3.088A8 8 0 0 1 2.898 2.4 8 8 0 0 1 5.412.707 7.7 7.7 0 0 1 8.498.083q1.643 0 3.088.624 1.446.623 2.514 1.692a8 8 0 0 1 1.693 2.513q.624 1.445.624 3.087a7.7 7.7 0 0 1-.624 3.087 8 8 0 0 1-1.692 2.515 8 8 0 0 1-2.513 1.692 7.7 7.7 0 0 1-3.087.624m-.001-1.25q2.791 0 4.73-1.938Q15.165 10.792 15.166 8q0-2.79-1.938-4.729-1.937-1.937-4.73-1.937-2.79 0-4.728 1.937t-1.938 4.73q0 2.79 1.938 4.728T8.5 14.667"
  })));
};
export default SvgCloseCircle;